import { Monitor } from './Monitor/Monitor';
import { IPairExtended } from './PairSpreadItem/PairSpreadItem';

type PairsData = {
    [key: string]: IPairExtended;
};

export interface IFutArbitrageStrategyState {
    futNearPeriod: string;
    futFarPeriod: string;
    pairsData: PairsData;
}

export interface IMonitorWebSocketState
{
    wsConnected: boolean;
    error: string | null;
    payload: IFutArbitrageStrategyState | null;
}

export const Home = () => {
    return (
        <>
            <Monitor />
        </>
    );
}